var include_campaign_pointcp = `
<ul class="banner-slider js-pointcp__slider">
<li>
    <a href="#kyotaru2302" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_kyotaru_f.png" alt="京樽&#12289;京樽・スシロー&#12289;回転寿司みさき(海鮮三崎港)&#12289;すし三崎丸&#12289;すし三崎港&#12289;スシローTo Go&#12289;人形町粋総本店 nanacoポイント2倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#new-chitose-airport2302" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_new-chitose-airport_f.png" alt="新千歳空港 nanacoポイント2倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#keikyu2302" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_keikyu_f.png" alt="京急百貨店 nanacoポイント5倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#hokkahokka-tei2301" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_hokkahokka-tei_f.png" alt="ほっかほっか亭 nanacoポイント2倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#tous2301" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_tous_f.png" alt="トウズ nanacoポイント2倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#rairaitei2301" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_rairaitei_f.png" alt="来来亭 nanacoポイント2倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#yakuodo2209" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_yakuodo2209_f.png" alt="薬王堂 nanacoポイント3倍"></div>
      </div>
    </a>
  </li>
  <li>
    <a href="#tsuruha2206" class="Nanaco_TopCampaign js-anchor link-anchor__img">
      <div class="banner-contents">
        <div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_tsuruha2206_f.png" alt="ツルハドラッグ nanacoポイント3倍"></div>
      </div>
    </a>
  </li>
</ul>
`;
